// @flow

import { getGateway } from '@tectonics/prs/gateway';
import type { PendingIncomingPayment } from './types';

export function getSafeExpirationDatetime(incomingPayment: PendingIncomingPayment): string {
  const gateway = getGateway(incomingPayment);
  const expirationDatetime = gateway['pix_expiration_datetime'];

  if(!expirationDatetime){
    throw new Error('Pix: no expiration date and time in incoming payment');
  }

  return expirationDatetime;
}
